import React from 'react'

import './Candidacy.css'
import HeadshotImage from '../../../assets/images/headshot.png'

const Candidacy = ({ candidate, position }) => (
  <div className="mx-md-4 my-5 Candidacy">
    <header className="clearfix mb-4 Candidacy__Header">
      <img
        alt={candidate.first_name}
        className="rounded-circle mb-4 mr-4 Candidacy__Headshot"
        height="104"
        src={candidate.photo_url || HeadshotImage}
        width="104"
      />
      <h1>{candidate.first_name} {candidate.last_name}</h1>
      {candidate.incumbent &&
        <span className="badge badge-secondary">Incumbent</span>
      }
    </header>
    <p>{candidate.first_name} is running for {position.name}.</p>
  </div>
)

export default Candidacy



// WEBPACK FOOTER //
// ./src/components/Position/Candidacy/Candidacy.js